import { isMobile,isTablet, deviceType } from "mobile-device-detect";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/compat/router";
import {
  Configure,
  
} from "react-instantsearch-dom";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { generalConstants } from "@/utils/constants";

const ConfigureComp = ({ type, collection, onlyWomen, buildertile1fetched, buildertile2fetched }) => {
  
  const router = useRouter();
  let contentTileCount = 0;
  let currentPage = router.query?.page || 1;
  let pathname = router.pathname;
  if(buildertile1fetched && buildertile2fetched && currentPage == 1) {
    contentTileCount = 2;
  }
  else if ((buildertile1fetched || buildertile2fetched) && currentPage == 1) {
    contentTileCount = 1;
  }
  // const router = useRouter();
  // const { category, subcategory, section,query } = router.query;
  const [hitCount, setHitCount] = useState(generalConstants.algolia_plp_hitcount_desktop);
  if( type == 'trends') {
    collection = 'trends';
  }
  const isTabletOrBelow = useMediaQuery("(max-width: 1024px");
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
     if(isMobile){
      if(contentTileCount == 0) {
        setHitCount(generalConstants.algolia_plp_hitcount_mobile-2);
      } else if(contentTileCount == 1){
        setHitCount(generalConstants.algolia_plp_hitcount_mobile+2);
      } else {
        setHitCount(generalConstants.algolia_plp_hitcount_mobile);
      }
      }else if(isTabletOrBelow){
        if(contentTileCount == 0) {
          setHitCount(generalConstants.algolia_plp_hitcount_tablet+4);
        } else if(contentTileCount == 1){
          setHitCount(generalConstants.algolia_plp_hitcount_tablet+2);
        } else {
          setHitCount(generalConstants.algolia_plp_hitcount_tablet);
        }
      }
      else {
        // Desktop
        if(contentTileCount == 0){
          setHitCount(generalConstants.algolia_plp_hitcount_desktop+2);
        } else if(contentTileCount == 1) {
          setHitCount(generalConstants.algolia_plp_hitcount_desktop+1);
        } else {
          setHitCount(generalConstants.algolia_plp_hitcount_desktop);
        }
      }
  }, [isMobile, isTabletOrBelow]);

  let deafultFilter = 'inventory_quantity>0';
  // let deafultFilter = '';
  // if (!section || !category) {
  //   if (section) {
  //     deafultFilter = "named_tags.categories.lvl0:'" + section + "'";
  //   }
  //   if (deafultFilter && category) {
  //     deafultFilter += " AND named_tags.categories.lvl1:'" + category + "'";
  //   } else if (category) {
  //     deafultFilter = "named_tags.categories.lvl1:'" + category + "'";
  //   }

  //   if (deafultFilter && subcategory) {
  //     deafultFilter += " AND named_tags.categories.lvl2:'" + subcategory + "'";
  //   } else if (subcategory) {
  //     deafultFilter = "named_tags.categories.lvl2:'" + subcategory + "'";
  //   }
  // }
  if (deafultFilter && collection) {
    deafultFilter += ` AND price_ratio=0 AND collections:${collection}`;
  } else if (collection) {
    deafultFilter = `price_ratio=0 AND collections:${collection}`;
  }
  if (deafultFilter && type == 'sale') {
    deafultFilter += " AND price_ratio > 0 AND price_ratio < 1 AND tags:'Discounted'";
  } else if (type == 'sale') {
    deafultFilter = "price_ratio > 0 AND price_ratio < 1 AND tags:'Discounted'";
  }

  if(onlyWomen) {
    deafultFilter = "price_ratio=0 AND inventory_quantity>0 AND (named_tags.categories.lvl0:'Clothing' OR named_tags.categories.lvl0:'Shoes' OR named_tags.categories.lvl0:'Bags & accessories')";
  }
  
  if(type == "newest"){
    deafultFilter = "price_ratio=0 AND inventory_quantity>0  AND (named_tags.Badge:'New')"
  }

  if(pathname == '/search') {
    deafultFilter = `inventory_available:true OR product_type:'${generalConstants.gift_card_type}'`
  }
 
 
  let conf = <Configure hitsPerPage={hitCount} />;
  if (deafultFilter) {
    conf = <Configure hitsPerPage={hitCount} filters={deafultFilter} />
  }

  return (
    conf
    
  );
};

export default ConfigureComp;
